import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import logo from "../../assets/images/logo-main-white.png";
import {
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Popover,
  List,
  ListItem,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import accessToken from "../../helpers/jwt-token-access/accessToken";
import jwtDecode from "jwt-decode";
import { Button } from "reactstrap";

const Layout = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const token = accessToken();
  const decoded = jwtDecode(token);
  const userName = decoded["email"];
  const userRole = decoded["cognito:groups"];

  const useStyles = makeStyles((theme) => ({
    appBar: {
      backgroundColor: "#193a6f",
    },
    activeButton: {
      color: "white", // change this to the desired active color
      marginLeft: "auto", // This will push the link to the right
      textDecoration: "none", // Remove text decoration from the link
      backgroundColor: '#f98125'
    },
    logo: {
      maxWidth: 160,
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    let currentage = capitalizeFirstLetter(props.location.pathname);
    document.title = currentage + " | CloudNova App";
  }, [props.location.pathname]);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(1).toUpperCase() + string.slice(2);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseAnchor = () => {
    setAnchorEl(null);
  };

  const openAnchor = Boolean(anchorEl);
  const id = openAnchor ? "simple-popover" : undefined;

  const history = useHistory();

  return (
    <React.Fragment>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Link to="/details">
            <img src={logo} alt="logo" className={classes.logo} />
          </Link>
          <div style={{ flexGrow: 1 }} />
          <div>
            <Button className={classes.activeButton} style={{marginRight: "5px"}} onClick={() => history.push("/details")}>Details</Button>
          </div>
          <div>
            {userRole.includes("Admin") && (
              <Button className={classes.activeButton} onClick={() => history.push("/users")}>User Management</Button>
            )}
          </div>
          <div>
            <Tooltip title={userName} placement="bottom">
              <IconButton color="inherit" onClick={handleClick}>
                <AccountCircleIcon />
              </IconButton>
            </Tooltip>
            <Popover
              id={id}
              open={openAnchor}
              anchorEl={anchorEl}
              onClose={handleCloseAnchor}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              PaperProps={{
                style: { backgroundColor: "#193a6f" },
              }}
            >
              <List>
                <ListItem className={classes.activeButton}>
                  <ListItemText primary={userName} />
                </ListItem>
                <Link className={classes.activeButton} to="/details">
                  <ListItem button>
                    <ListItemText primary="Details" />
                  </ListItem>
                </Link>
                {userRole.includes("Admin") && (
                  <Link className={classes.activeButton} to="/users">
                    <ListItem button>
                      <ListItemText primary="User Management" />
                    </ListItem>
                  </Link>
                )}
                <Link className={classes.activeButton} to="/logout">
                  <ListItem button>
                    <ListItemText primary="Log Out" />
                  </ListItem>
                </Link>
              </List>
            </Popover>
          </div>
        </Toolbar>
      </AppBar>
      {props.children}
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  return {
    ...state.layout,
  };
};
export default connect(mapStatetoProps, null)(withRouter(Layout));
